<template>
  <div class="mt-4 date-request-form-private-date">
    <label class="form-label required" for="privateRequestDate">{{
      t('product.show.checkout.selectDate')
    }}</label>
    <div class="mt-1 relative w-full hidden sm:block">
      <Datepicker
        v-model="date"
        model-type="yyyy-MM-dd'T'HH:mm"
        time-picker-inline
        :format-locale="deLocale"
        format="dd.MM.yyyy, HH:mm"
        locale="de"
        :select-text="t('dateRequest.instantBooking.datePickerSelect')"
        text-input
        minutes-increment="30"
        :start-time="startTime"
        :placeholder="t('product.show.checkout.selectDate')"
        @open="emit('clear-errors', 'dates')"
      />
    </div>
    <div class="mt-1 relative w-full sm:hidden">
      <div class="relative w-full">
        <input
          id="privateRequestDate"
          v-model="date"
          :min="minDateFormatted"
          data-test-id="date-request-date-picker-1"
          step="1800"
          :placeholder="t('product.show.checkout.selectDate')"
          type="datetime-local"
          class="box-border min-w-0 w-full text-left rounded-lg border border-gray-200 bg-white ![padding-block-start:0.25rem] ![padding-block-end:0.25rem] ![padding-inline-start:0] ![padding-inline-end:0]"
          name="privateRequestDate"
          @input="onNativeInput"
        />
      </div>
    </div>
    <span
      v-if="dateError"
      data-test-id="date-request-form-invalid"
      class="text-red text-sm"
    >
      {{ dateError }}
    </span>
    <span class="block mb-2 text-xs text-gray-400">
      {{ t('subscribeToEventUpdatesModal.firstStep.form.date1.helperText') }}
    </span>
  </div>
</template>

<script setup lang="ts">
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { de as deLocale } from 'date-fns/locale'
import type {
  DateRequestErrors,
  DateRequestInvalidKeys,
} from '~/components/date-request/dateRequestTypes'

interface Props {
  minDateFormatted: string
  startTime: { hours: number; minutes: number }
  errors?: DateRequestErrors | null
  invalidKeys?: DateRequestInvalidKeys
}

const {
  minDateFormatted,
  startTime,
  errors = {},
  invalidKeys: _invalidKeys = [],
} = defineProps<Props>()

const date = defineModel<string | undefined>('date', { required: true })

const emit = defineEmits<{
  (e: 'native-input', event: Event): void
  (e: 'clear-errors', field: string): void
}>()

const { t } = useI18n()

const dateError = computed(() => errors?.dateSlots?.[0] ?? errors?.dates)

/** Mobile datetime-local has no @open; clear on input like desktop datepicker @open. */
const onNativeInput = (event: Event) => {
  emit('clear-errors', 'dates')
  emit('native-input', event)
}
</script>

<style lang="postcss" scoped>
.dp__menu {
  font-family: 'Lexend';
}
:deep(.dp__input) {
  @apply rounded-lg;
}
.required:after {
  content: '*';
  position: relative;
  font-size: inherit;
  @apply text-red;
  padding-left: 0.25rem;
  font-weight: 700;
}
</style>
